import React from "react";
import { HtmlReactParser } from "@kaltura/mediaspace-shared-utils";
import styled from "@emotion/styled";
import { Button, Typography } from "@kaltura/ds-react-components";

export interface ContactUsProps {
    title?: string;
    buttonLabel?: string;
    buttonLink?: string;
    additionalInfo?: string;
}

const StyledContactUs = styled("div")(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: theme.kaltura.palette.surfaces.paper,
    textAlign: "center",
    flexFlow: "column wrap",
    padding: theme.spacing(3),
    marginBottom: theme.spacing(3),
    boxSizing: "border-box",
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
        width: 309,
        marginLeft: theme.spacing(2),
    },
    [theme.breakpoints.up(theme.breakpoints.values.lg)]: {
        width: 378,
        marginLeft: theme.spacing(4),
    },
    [theme.breakpoints.up(theme.breakpoints.values.xl)]: {
        width: 419,
    },
}));

const StyledButton = styled(Button)(({ theme }) => ({
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
}));

/**
 * Component to render a ContactUsSection inside event platform filters
 */
const ContactUs = ({ title = "", buttonLabel = "", buttonLink = "", additionalInfo = "" }: ContactUsProps) => {
    const handleClick = () => {
        window.open(buttonLink, "_blank");
    };

    return (
        <div>
            <StyledContactUs className="kms-ds-help-page-contact-us">
                {title && (
                    <Typography variant={"body2"} className="kms-ds-help-page-contact-us-title">
                        {HtmlReactParser(title)}
                    </Typography>
                )}
                {buttonLabel && (
                    <StyledButton onClick={handleClick} disabled={buttonLink === ""}>
                        {buttonLabel}
                    </StyledButton>
                )}
                {additionalInfo && (
                    <Typography variant={"body2"} className="kms-ds-help-page-contact-us-info">
                        {HtmlReactParser(additionalInfo)}
                    </Typography>
                )}
            </StyledContactUs>
        </div>
    );
};

export default ContactUs;
